import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getVideoConversionTemplatesByEntityId } from "./actions";

export const videoConversionTemplateEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = videoConversionTemplateEntityAdapter.getInitialState({
  isLoading: false,
  selectedVideoConversionTemplate: {},
  totalCount: 0,
});

export const videoConversionTemplateSlice = createSlice({
  name: "videoConversionTemplate",
  initialState: initialState,
  reducers: {
    setSelectedVideoConversionTemplate: (state, action) => {
      state.selectedVideoConversionTemplate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVideoConversionTemplatesByEntityId.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getVideoConversionTemplatesByEntityId.fulfilled, (state, action) => {
      if (action.payload.success) {
        videoConversionTemplateEntityAdapter.setAll(state, action.payload.data);
        state.totalCount = action.payload.totalCounts;
      }
      state.isLoading = false;
    });
  },
});

export const { setSelectedVideoConversionTemplate } = videoConversionTemplateSlice.actions;

export default videoConversionTemplateSlice.reducer;
